import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import './TestimonialWeb.css';

const TestimonialWeb = () => {
    const testimonialInfo = [
        {
            body: "The video and product photography were great, Bhavik cooperated well to the changes required, true value for money",
            name: "Mukul Jain",
            designation: "Kids-e-Dental",
            key: 0
        },
        {
            body: "It's a good job done by Bhavik as he makes the product look natural and attractive, his understanding of lights and background for the product is good, his nature is also friendly and my experience as his customer is superb because he finished work before my expected time so I am really happy with Bhavik's work.",
            name: "Ayush Chopra",
            designation: "Shankeshwar Enterprises",
            key: 1
        },
        {
            body: "Love video production. Transition in videos is too good. Editing is a masterclass. The sound is great. Video conceptualization is good. Love it......",
            name: "Viraj yadav",
            designation: "Director, Deepleed Innovation Pvt. Ltd.",
            key: 2
        },
        {
            body: "My favorite part about working with One Rock is their team. They went above and beyond from the get-go. We could trust them to do anything we needed.",
            name: "Pradeep Nadar",
            designation: "AP Mani & Sons",
            key: 3
        }
    ];

    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
          slidesToSlide: 1 
        },
        tablet: {
          breakpoint: { max: 1024, min: 481 },
          items: 1,
          slidesToSlide: 1 
        },
        mobile: {
          breakpoint: { max: 480, min: 0 },
          items: 1,
          slidesToSlide: 1 
        }
      };


    return (
        <div className="testimonial-web container">
            <p id="testimonial-web-title">HEAR FROM OUR CLIENTS</p>
            <Carousel 
            responsive={responsive}
            swipeable={false}
            draggable={false}
            infinite={true}
            keyBoardControl={true}
            transitionDuration={1500}
            autoPlay={true}
            autoPlaySpeed={10000}
            showDots={true}
            renderDotsOutside={false}
            dotListClass="testimonial-custom-dots">
                {testimonialInfo.map((item,index) => (
                    <div className="testimonial-web-card d-flex flex-column" key={item.key}>
                        <p className="testimonial-web-card-content">
                            {item.body}
                        </p>
                        <div className="testimonial-web-card-content-name" >
                            <p style={{marginBottom:5}}>{item.name}</p>
                            <p className="testimonial-web-card-content-designation">{item.designation}</p>
                        </div>
                    </div>
                ) )}
            </Carousel>
        </div>
    );
};

export default TestimonialWeb;


// WEBPACK FOOTER //
// ./src/components/testimonial/testimonial-web/TestimonialWeb.js